<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      :stroke="strokeCode"
      d="M6 9L11.5 15L17 9"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script lang="ts" setup>
  const { stroke } = defineProps({
    stroke: {
      type: String,
      default: undefined,
    },
    size: {
      type: String,
      default: '24',
    },
  })

  const style = getComputedStyle(document.body)

  const strokeCode = style.getPropertyValue(stroke ?? '--Gray-800')
</script>
<style scoped>
  svg {
    color: var(--Gray-800);
    stroke: var(--Gray-800);
  }
</style>
